export { default as StudentInfo } from './StudentInfo.vue';
export { default as History } from './History.vue';
export { default as Ogp } from './Ogp.vue';
